import { IAuthClient } from "../../auth";
import { ServiceResponse } from "../../common";
import { ICommsClient } from "../../comms";
import { IEventsClient } from "../../events";
import { IFilesClient } from "../../files";
import { IFormsClient } from "../../forms";
import { ILookupsClient } from "../../lookups";
import { IRegistryClient } from "../../registry";

const IPlatformClientId = "@se/platform:IPlatformClient";

interface IPlatformClient {
    auth: IAuthClient;
    files: IFilesClient;
    registry: IRegistryClient;
    comms: ICommsClient;
    lookups: ILookupsClient;
    events: IEventsClient;
    forms: IFormsClient;

    GetAuthScopes(accessToken: string): Promise<ServiceResponse<Array<string>>>
    GetDependencies(accessToken: string): Promise<ServiceResponse<Array<object>>>

};

export { IPlatformClientId, IPlatformClient };